<template>
  <div class="fego-dashboard">
    <!-- Sidebar -->
    <div class="sidebar">
      <sidebarComponent />
    </div>

    <!-- Main Content -->
    <div class="main-content">
      <h2 class="section-title">Bonuses Management</h2>

      <div class="card">
        <h3>Create / Manage Bonuses</h3>

        <div class="grid-2">
          <div class="form-card">
            <label>Bonus Title</label>
            <input
              v-model="form.title"
              placeholder="e.g. Weekly Driver Reward"
            />

            <label>Bonus Amount (EGP)</label>
            <input type="number" v-model.number="form.amount" min="0" />

            <label>Description</label>
            <textarea
              v-model="form.description"
              placeholder="Bonus description..."
            ></textarea>

            <div class="actions">
              <button @click="createBonus">Create Bonus</button>
              <button class="secondary" @click="resetForm">Reset</button>
            </div>
          </div>
        </div>

        <div class="list-card">
          <h3>Existing Bonuses</h3>

          <div v-if="bonuses.length === 0" class="empty">No bonuses found</div>

          <div v-for="bonus in bonuses" :key="bonus.id" class="bonus-row">
            <div class="bonus-info">
              <strong>{{ bonus.title }}</strong>
              <p>{{ bonus.description }}</p>
              <small>Reward: {{ bonus.amount }} EGP</small>
            </div>
            <div class="row-actions">
              <button class="secondary">Edit</button>
              <button class="danger" @click="deleteBonus(bonus)">Delete</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sidebarComponent from "@/components/sidebarComponent.vue";

export default {
  name: "bounsPage",
  components: { sidebarComponent },
  data() {
    return {
      form: {
        title: "",
        amount: 0,
        description: "",
      },
      bonuses: [],
    };
  },
  methods: {
    createBonus() {
      if (!this.form.title || this.form.amount <= 0) {
        alert("Please enter a valid title and amount.");
        return;
      }
      const newBonus = { ...this.form, id: Date.now() };
      this.bonuses.push(newBonus);
      alert("Bonus created successfully!");
      this.resetForm();
    },
    deleteBonus(bonus) {
      if (confirm(`Are you sure you want to delete "${bonus.title}"?`)) {
        this.bonuses = this.bonuses.filter((b) => b.id !== bonus.id);
      }
    },
    resetForm() {
      this.form = { title: "", amount: 0, description: "" };
    },
  },
};
</script>

<style scoped>
.fego-dashboard {
  display: flex;
  min-height: 100vh;
  font-family: Arial, sans-serif;
}
.sidebar {
  width: 250px;
  background: #6b5b95;
  color: #fff;
  padding: 20px;
}
.main-content {
  flex: 1;
  padding: 30px;
  background: #f5f7fa;
}
.card {
  background: #fff;
  border: 2px solid #8e44ad;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}
.section-title {
  margin: 0 0 16px;
  color: #2c3e50;
}
.grid-2 {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}
.form-card,
.list-card {
  border: 2px solid #8e44ad;
  border-radius: 10px;
  padding: 16px;
  background: #fff;
  margin-bottom: 20px;
}
input,
textarea {
  width: 100%;
  padding: 8px;
  margin-top: 6px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #f5f5ff;
}
button {
  width: 100%;
  padding: 10px;
  background: #8e44ad;
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  margin-top: 12px;
}
button.secondary {
  background: #5d6d7e;
}
button.danger {
  background: #c0392b;
}
.bonus-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  background: #f5f5ff;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 10px;
  margin-bottom: 10px;
}
.bonus-info p {
  margin: 4px 0;
  color: #555;
}
.empty {
  color: #7f8c8d;
  font-style: italic;
}
</style>
